module.exports = __webpack_public_path__ + "img/梁老板.13ba622f.png";